import { render, staticRenderFns } from "./InformarDatas.vue?vue&type=template&id=788c04a4&"
import script from "./InformarDatas.vue?vue&type=script&lang=js&"
export * from "./InformarDatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports